<template>
    <section class="charts">
      <highcharts class="chart" :options="pieOptions" ref="pieCharts"></highcharts>
    </section>
</template>
<script>
//import VueHighcharts from '../../src/VueHighcharts.vue'
import * as data from '../assets/js/chartdata'
export default {
  components: {
   // VueHighcharts,
  },
  data() {
    return {
      pieOptions: {    
          chart: {
              type: 'pie',
              options3d: {
                  enabled: false,
                  alpha: 45
              }
          },
          title: {
              text: ''
          },
          subtitle: {
              text: ''
          },
          credits: {
              enabled: false
          },
          plotOptions: {
              pie: {
                  innerSize: 100,
                  depth: 45,
                  allowPointSelect: true,
                  cursor: 'pointer',
                  dataLabels: {
                    enabled: true,
                    format: '<b>{point.name}</b><br>{point.percentage:.1f} %',
                    distance: -50,
                    filter: {
                        property: 'percentage',
                        operator: '>',
                        value: 4
                    }
                      
                  },
              }
          },
          series: [{
              name: '발견건수',
              data: []
          }]
      },
      chartDataInterval: ''
    }
  },
  created () {
  //  this.changChartColor()
    this.updateChart()
  },
  beforeDestroy () {
    clearInterval(this.chartDataInterval)
  },
  methods: {
    randomRange(n1, n2) {
      return Math.floor( (Math.random() * (n2 - n1 + 1)) + n1 )
    },
    updateChart () {
      this.chartDataInterval = setInterval(() => {
        let chart = this.$refs.pieCharts.chart
        //console.log(chart)
        let args = []
        let values = []
        let title = ['Linearity', 'Inking','Air Gap','Overcured','Carbonization','Wave','Curl','Cratering','Swaging']
        for (let i in title ) {
          let v = this.randomRange(0,20)
          args.push([title[i], v])
        }
       // console.log(args)
        this.pieOptions.series[0].data = args
        
      }, 5000)
    },
    changChartColor() {
      const vm = this
      vm.Highcharts.setOptions({
        colors: Highcharts.map(Highcharts.getOptions().colors, function (color) {
          return {
            radialGradient: {
              cx: 0.5,
              cy: 0.3,
              r: 0.7
            },
             stops: [
                [0, color],
                [1, Highcharts.Color(color).brighten(-0.3).get('rgb')] // darken
              ]
            }
        })
      })
    }
  }
}
</script>